/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { useEffect, useMemo, useState } from 'react';
import { TerminalPageData } from '@/types/dashboard/TeminalPage';
import { getArmadoresList } from '@/services/getListArmadores';
import { getDashboardTerminalPageData } from '@/services/dashboardTerminalPage';
import useAuthContext from '../useAuthContext';

export const useTerminalPage = () => {
  const { userDataDecoded } = useAuthContext();
  const [currentArmador, setCurrentArmador] = useState({ value: '', name: '' });
  const [terminalPageData, setTerminalPageData] = useState<TerminalPageData>();
  const [isInitialPageData, setIsInitialPageData] = useState(true);
  const [isInitialArmador, setIsInitialArmador] = useState(true);
  const [loading, setLoading] = useState(true);
  const armadoresDashboard = useMemo(() => {
    return userDataDecoded?.armadoresDashboard?.split(';') || [];
  }, [userDataDecoded]);

  // Obtener la lista de armadores
  const { data: armadoresList, isLoading: loadingArmadores } = useQuery({
    queryKey: ['armadoresListDropdownTerminal'],
    queryFn: getArmadoresList,
  });

  // Obtener los datos de la página basado en el viaje actual
  const { data: pageData, isLoading: loadingPageData } = useQuery({
    queryKey: ['terminalPageData', currentArmador.value], // Asegurar que armador.value es parte de la queryKey
    queryFn: () =>
      getDashboardTerminalPageData({ armador: currentArmador.value }),
    enabled: currentArmador.value !== '', // Habilitar solo si currentArmador.value no está vacío
  });

  // Generar opciones para el dropdown de armadores
  const options = (
    userDataDecoded?.armadoresDashboard || userDataDecoded?.armadores
  )
    ?.split(';')
    .map((val) => {
      return { value: val, name: val };
    });
  const shipownerOptions = armadoresList?.map(
    (val: { codigo: string; nombre: string }) => {
      return { value: val.codigo, name: val.nombre };
    }
  );

  const armadoresListForDropdown =
    userDataDecoded?.armadores === '*' ? shipownerOptions : options;

  // Efecto para inicializar currentArmador una vez
  useEffect(() => {
    if (
      isInitialArmador &&
      armadoresListForDropdown &&
      armadoresListForDropdown.length > 0
    ) {
      setCurrentArmador(armadoresListForDropdown[0]);
      setIsInitialArmador(false); // Marcar como ejecutado
    }
  }, [isInitialArmador, armadoresListForDropdown]);

  useEffect(() => {
    if (pageData) {
      setTerminalPageData(pageData);
      setIsInitialPageData(false); // Marcar como ejecutado
    }
  }, [isInitialPageData, pageData, currentArmador]);

  useEffect(() => {
    if (!loadingArmadores && !loadingPageData && pageData) {
      setLoading(false);
    }
  }, [loadingArmadores, loadingPageData, pageData]);

  return {
    armadoresListForDropdown,
    currentArmador,
    setCurrentArmador,
    terminalPageData,
    pageData,
    loadingArmadores,
    loadingPageData,
    loading,
    armadoresDashboard,
  };
};
